<script setup>
import {onMounted, reactive, ref} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {ToastUtil} from "@/Utils/ToastUtil";
import { useRouter } from 'vue-router';

const compName = 'ClaimCreatorComponent';

const data = reactive({
  loading: true,
  valid: true,
  claimLink: null,
  claim: {
    number: null,
    id: null
  },
  clientId: null,
  clients: []
});

const form = ref(null);
const router = useRouter();

const addClaim = () => {
  if (form.value.validate()) {
    data.loading = true
    ApiWrapper.post('claims', 'create', {
          claim: data.claim,
          clientId: data.clientId
        })
        .then((response) => {
          activeComponentStore.notifyComponents(['claims'],compName);
          data.claim.id = response.claim.id

          clearClaim()
          data.loading = false
          ToastUtil.successMsg('Created claim');
          router.push({
            path: `/claim/${response.claim.id}`
          });
        })
        .catch((err) => {
          ToastUtil.error(err);
          data.loading = false;
        })
  }
}

const getAllClients = async () => {
  data.loading = true;

  await ApiWrapper.get('claims', 'all-clients')
      .then((response) => {
        data.clients = [
            {
              title: 'None',
              key: null
            },
            ...response.clients.map((client) => {
              return {
                title: client.name,
                key: client.id
              }
            })
        ];
      })
      .catch((e)=>{
        data.clients = [{
          title: 'None',
          key: null
        }];
      })
      .finally(() => {
        data.loading = false;
      })
}

const getData = async() => {
  await getAllClients();
}

const clearClaim = () => {
  form.value.reset();
  data.claim.number = null
  data.clientId = null;
}

onMounted(()=>{
  getData();
});

</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Create Claim</v-toolbar-title>
        <v-progress-linear :active="data.loading" :indeterminate="data.loading" absolute bottom color="primary">
        </v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>

      <v-form ref="form" v-model="data.valid" lazy-validation>
        <v-row class="px-5">
          <v-col cols="12">
            <v-text-field v-model="data.claim.number" type="text" label="Claim Number" :rules="[v => !!v || 'Claim Number is required']"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-select
                :items="data.clients"
                v-model="data.clientId"
                label="Client"
                item-title="title"
                item-value="key"
                clearable
            ></v-select>
          </v-col>
        </v-row>

        <v-card-actions>
          <v-btn color="primary" variant="elevated" :disabled="!data.valid" @click="addClaim">
            Add Claim
          </v-btn>
          <v-btn color="primary" variant="elevated" @click="clearClaim">Reset Form</v-btn>
        </v-card-actions>
      </v-form>
      <RouterLink :to="`/claim/${data.claim.id}`" v-if="data.claim.id !== null">
         Click here if not automatically redirected
      </RouterLink>
    </v-card>
  </v-container>
</template>

<style scoped>
v-container {
  padding: 5px;
}

[v-cloak] {
  display: none;
}
</style>